import { useEffect, useState } from "react";
import axios from "axios";
import { getRoute } from "../routes";
import { formatDate } from "../utils";

export default function useTaxRate({ serviceTypeId, amount = 1, amountType = "NET", date }) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState("pending");
  const [error, setError] = useState(null);

  const onDate = date && formatDate.toHttpFormatStartOfDay(date);

  const args = {
    serviceTypeId,
    amount,
    amountType,
    onDate,
  };

  const queryString = Object.entries(args)
    .filter(([, value]) => value)
    .map(([param, value]) => `${param}=${encodeURIComponent(value)}`)
    .join("&");
  const url = `${getRoute("offerings-api", "taxes", "summary")}?${queryString}`;

  useEffect(() => {
    let didCancel = false;

    const fetchData = async () => {
      try {
        const { data } = await axios(url);
        // иммитация смены ставки
        // if (onDate.includes('2021-01-13')) {
        //   data.taxRate = 12;
        //   data.tax = 0.12;
        // }
        const tax = parseFloat(data?.tax);

        if (tax >= 0) {
          data.taxRateNum = tax;
        } else {
          data.taxRateNum = data?.tax;
        }

        if (!didCancel) {
          setResult(data);
          setLoading("fulfilled");
        }
      } catch (e) {
        if (!didCancel) {
          setLoading("rejected");
          setError(e.response?.data?.message || "Что-то пошло не так...");
        }
      }
    };

    if (serviceTypeId) {
      fetchData();
    }

    return () => {
      didCancel = true;
    };
  }, [onDate, url, serviceTypeId, amount, amountType, date]);

  return [result, loading, error];
}
